
<ngx-loading [show]="loading" ></ngx-loading>
<mat-card class="back">

    <mat-card-header>
        <mat-card-title-group>
        <!-- <mat-card-title class="cardtitle">
            <a routerLink="/login" >Home Fabrics</a> 
        </mat-card-title> -->
        <!-- <mat-card-subtitle>Enter Details To Reset Password</mat-card-subtitle> -->
        </mat-card-title-group>
    </mat-card-header>

    <form [formGroup]="resetFormGroup" class="example-form" (ngSubmit)="resetPassword()">
        <span>
            <h3>Enter Email Details</h3>
        </span><br>
        <div>
            <br>
            <mat-form-field class="example-full-width">
                <input type="email" matInput formControlName="emailId" placeholder="Email Id" required>
            </mat-form-field>
            <br>
            <mat-form-field class="example-full-width">
                <input type="password" matInput  formControlName="newPassword" placeholder="New Password" required>
            </mat-form-field>
            <br>
            <mat-form-field class="example-full-width">
                <input type="password" matInput  formControlName="confirmPassword" placeholder="Confirm Password" required>
            </mat-form-field>
            <br>
        </div>

        <div>
            <button mat-raised-button color="primary" [disabled]="loading">Reset password</button>
        </div>

    </form>

</mat-card>





















<!-- <mat-card class="back">

    <form  class="example-form" [formGroup]="resetFormGroup" >
        <span>
            <h3>Enter Email details</h3>
        </span><br>
        <div>
            <br>
            <mat-form-field class="example-full-width">
                <input matInput  formControlName="email" placeholder="Email Id" required>
            </mat-form-field>
            <br>
            <mat-form-field class="example-full-width">
                <input matInput type="password" formControlName="newPassword" placeholder="New Password" required>
            </mat-form-field>
            <br>
            <mat-form-field class="example-full-width">
                <input matInput type="password" formControlName="confirmPassword" placeholder="Confirm Password" required>
            </mat-form-field>
            <br>
        </div>

        <div>
            <button mat-raised-button color="primary" (click)="resetPassword()">Reset Password</button>
        </div>

    </form>

</mat-card> -->